export default __webpack_public_path__ + "static/media/basiercircle-regular-webfont.60b3e197.eot";